import React from 'react';
import './Publication';
import { EditableList, Input } from '../index';
import { Row } from 'antd';
import PropTypes from 'prop-types';
import './Publication.css';
import { SEGMENTIO } from '../../../constants/segmentio';

function Publication (props) {
  const handleValidation = (item) => {
    if (!item.year) item.error('year', 'Please select the year');
    if (!item.title) item.error('title', 'Please type the title');
    if (!item.link) item.error('link', 'Please type the link');
  };

  return (
    <EditableList
      {...props}
      onChange={props.onChange}
      textAddButton="Add Publication"
      addEvent={SEGMENTIO.PROFILE_ADD_PUBLICATION_EVENT_CLICKED}
      cancelEvent={SEGMENTIO.PROFILE_CANCEL_PUBLICATION_EVENT_CLICKED}
      saveEvent={SEGMENTIO.PROFILE_SAVE_PUBLICATION_EVENT_CLICKED}
      dataSource={props.publications || []}
      allowAdd
      addTitle="Add a new publication"
      editTitle="Update publication"
      validation={handleValidation}
      renderForm={(item) => <PublicationForm {...item} />}
      renderItem={(item, i) => <PublicationItem {...item} key={i} />}
    />
  );
}

const PublicationForm = React.memo((props) => {
  const year = (new Date()).getFullYear();
  return (
    <Row gutter={[12, 0]}>
      <Input
        span={24}
        {...props.bind('title', { defaultValue: '' })}
        label="Title"
        placeholder="Title"
      />
      <Input.Select
        span={24}
        {...props.bind('year')}
        label="Year"
        placeholder="Year"
        options={[...new Array(50)].map((v, i) => ({
          value: year - i,
          label: year - i
        }))}
      />
      <Input
        span={24}
        {...props.bind('link', { defaultValue: '' })}
        label="Link"
        placeholder="Link"
      />
    </Row>
  );
});

const PublicationItem = React.memo((props) => {
  return (
    <div className="publication-item">
      <small>{props.year}</small>
      <h3>{props.title}</h3>
      <span>{props.link}</span>
    </div>
  );
});

PublicationItem.propTypes = {
  year: PropTypes.number,
  title: PropTypes.string,
  link: PropTypes.string
};

Publication.propTypes = {
  onChange: PropTypes.func,
  publications: PropTypes.array
};

PublicationForm.propTypes = {
  bind: PropTypes.func
};

export default Publication;
